import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.irMapping.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.irMapping.actionsLoading;
export const getItems = (state:RootState) => state.irMapping.items;
export const getItemsSelect = (state:RootState) => state.irMapping.dropDownItems;
export const getItemsCount = (state:RootState) => state.irMapping.itemsCount;
export const getItemForEdit = (state:RootState) => state.irMapping.itemForEdit;
export const getError = (state:RootState) => state.irMapping.error;
export const getErrorAction = (state:RootState) => state.irMapping.errorAction;
export const validationErrors = (state: RootState) => state.irMapping.validationErrors;
